var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.srcImagem)?_c('v-avatar',[(_vm.propriedade)?[_c('v-img',{attrs:{"src":_vm.srcImagem[_vm.propriedade],"contain":""}})]:[_c('v-img',{attrs:{"src":_vm.srcImagem,"contain":""}})]],2):_c('v-avatar',[_c('v-icon',[_vm._v(" mdi-camera ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }